import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { hrefByRelationship } from 'Views/Page/Content/Templates';
import { assertSafeSpreadAttributes } from 'Packages/FacetCore/Experimental/helpers';
import { useNavigateByRelationshipOnClick } from 'Views/Page/Hooks/useNavigateByRelationshipOnClick';

export const PrimaryActionButtonRel = ({
  relationship, beforeOnClick, overrideOnClick, afterSuccessfulOnClick, loading: forceLoading, disabled, alignSelf, forceFocusMode, size, iconPosition, isFullWidth, ...rest
}) => {
  const { onClick, loading } = useNavigateByRelationshipOnClick(relationship, {
    beforeOnClick,
    overrideOnClick,
    afterSuccessfulOnClick,
    forceLoading,
    forceFocusMode,
  });

  assertSafeSpreadAttributes(rest);

  // The relationship could have been missing, in which case we shouldn't render
  if (!relationship) {
    return null;
  }

  return (
    <FDPrimaryActionButton
      {...rest}
      size={size}
      icon={relationship.meta('icon')}
      iconPosition={iconPosition}
      alignSelf={alignSelf}
      label={relationship.meta('prompt')}
      loading={loading}
      onClick={onClick}
      disabled={disabled || relationship.meta('disabled')}
      href={hrefByRelationship(relationship)}
      isFullWidth={isFullWidth}
    />
  );
};

PrimaryActionButtonRel.defaultProps = {
  relationship: undefined,
  alignSelf: undefined,
  loading: undefined,
  disabled: undefined,
};

PrimaryActionButtonRel.propTypes = {
  forceFocusMode: PropTypes.bool,
  relationship: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  iconPosition: PropTypes.string,
  alignSelf: PropTypes.oneOf(['flex-start', 'center', 'flex-end', undefined]),
};
